<template>
	<div id="yyjj">
		<div class="content" v-html="yyjj">
			
		</div>
	</div>
	</div>
</template>
<style lang="scss" scoped>
	p img{
		width: 100%!important;
	}
	#yyjj {
		font-size: 30px!important;
		line-height: 60px;
		p img{
			width: 100%!important;
		}
		
		.content {
			width: 100%;
			padding: 0 20px;
			text-align: center;

			img {
				width: 100%;
				display: block;
			}

			h2 {
				text-align: center;
				font-size: 34px;
				line-height: 34px;
				padding: 30px 0;
			}

			p {
				text-indent: 2em;
				color: #000;
				font-size: 30px;
				line-height: 60px;
				text-align: left;
			}
		}
	}
	
</style>

<script>
	import {
		Toast
	} from 'mint-ui';
	export default {
		name: "Home",
		data() {
			return {
				yyjj:null

			};
		},
		created() {
			this.getYyjjData();
		},
		mounted() {},
		methods: {
			getYyjjData() {
				let params = {
					params: {

					}
				};
				this.$http.get(this.$api.GHyyjj, params).then(res => {
					// console.log('获取医生成功');
					console.log(res);
					if (res.data.code == 0) {
						this.yyjj = res.data.data[0].yyjj;
					} else {
						Toast({
							message: res.data.msg,
							position: 'center',
							duration: 2000
						});
					}
				}).catch(error => {
					// console.log('获取医生失败');
					// console.log(error);
					Toast({
						message: error.data.msg || error.data.message,
						position: 'center',
					});
				});
			}


		}
	};
</script>
